var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSplitevLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 41,
    viewBox: "0 0 194 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_15176_271490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.57 24.0773V0.919434H131.633V17.2624L147.814 0.919434H154.902L130.825 24.0773H126.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.32 24.0773V0.919434H125.053V4.23709H111.21V10.6425H124.146V13.993H111.21V20.7268H125.053V24.0773H106.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9485 24.0773V2.69323H79.9961V0.919434H102.272V2.69323H92.3589V24.0773H89.9485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9023 24.0773V0.919434H75.4337V24.0773H72.9023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1445 24.0773V0.919434H54.5591V22.2707H68.8518V24.0773H52.1445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8203 24.0773V0.919434H36.8738C39.8052 0.919434 42.0643 1.4888 43.6511 2.62753C45.2647 3.76627 46.0715 5.36487 46.0715 7.42335C46.0715 9.43803 45.2647 11.0257 43.6511 12.1863C42.0643 13.347 39.8052 13.9273 36.8738 13.9273H28.3215V24.0773H25.8203ZM28.3215 12.1535H36.7124C38.9446 12.1535 40.6389 11.7483 41.7954 10.9381C42.9518 10.1059 43.53 8.93436 43.53 7.42335C43.53 5.91234 42.9518 4.74076 41.7954 3.90861C40.6389 3.07646 38.9446 2.66038 36.7124 2.66038H28.3215V12.1535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7006 24.5C8.421 24.5 6.40962 24.2559 4.66642 23.7677C2.92322 23.2795 1.36774 22.5693 0 21.6373L1.04592 19.9397C2.01139 20.561 2.95003 21.0714 3.86186 21.4709C4.80051 21.8703 5.81961 22.1699 6.91917 22.3696C8.01873 22.5472 9.26579 22.6359 10.6603 22.6359C13.1545 22.6359 15.0318 22.2365 16.2922 21.4376C17.5527 20.6165 18.1829 19.5402 18.1829 18.2087C18.1829 17.0548 17.7404 16.1782 16.8554 15.5791C15.9972 14.9577 14.482 14.4695 12.3097 14.1144L8.20646 13.4154C5.60506 12.9716 3.66072 12.2614 2.37344 11.285C1.11297 10.3086 0.482733 8.97712 0.482733 7.29057C0.482733 5.9147 0.911829 4.71637 1.77002 3.69556C2.62821 2.67476 3.82163 1.88696 5.35029 1.33218C6.87894 0.777393 8.64896 0.5 10.6603 0.5C12.6717 0.5 14.4954 0.755201 16.1313 1.2656C17.7941 1.75381 19.2154 2.48613 20.3955 3.46255L19.3898 5.12691C18.1293 4.15049 16.8018 3.45146 15.4072 3.02982C14.0127 2.58599 12.4304 2.36408 10.6603 2.36408C8.32714 2.36408 6.47666 2.80791 5.10892 3.69556C3.74118 4.56103 3.05731 5.73717 3.05731 7.22399C3.05731 8.42233 3.4864 9.35437 4.34459 10.0201C5.22961 10.6859 6.65098 11.1852 8.60873 11.518L12.7522 12.2171C15.5145 12.6831 17.5393 13.371 18.8266 14.2809C20.1139 15.1685 20.7575 16.4445 20.7575 18.1089C20.7575 19.3738 20.3418 20.4945 19.5105 21.4709C18.7059 22.4251 17.5527 23.1685 16.0509 23.7011C14.549 24.2337 12.7656 24.5 10.7006 24.5Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.567 16.6119L168.193 26.5L171.267 23.4273L168.429 20.8273L175.76 13.7364L178.598 16.3364L181.673 13.2636L179.071 10.6636L189.477 0.5H168.193L157.514 10.8052C155.864 12.3979 155.888 15.0494 157.567 16.6119Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.49 15.5L157.477 40.5H180.43L192.279 29.7615C194.004 28.1978 194.035 25.4967 192.345 23.8947L183.49 15.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_15176_271490",
    x: -0.01,
    y: 0.49,
    width: 154.922,
    height: 24.02,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_15176_271490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_15176_271490",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitevLogo);
export default __webpack_public_path__ + "static/media/splitev_logo.f2274fb891807dc0e4ffa47d823511ab.svg";
export { ForwardRef as ReactComponent };